import { Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { styles } from "../../style";
import dayjs from "dayjs";

const Page1 = ({ data }) => {
  const todayDate = dayjs().format("YYYY оны MM сарын DD өдөр");

  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={[styles.title, styles.textBold, { letterSpacing: 0.5 }]}>
          ОЮУНЫ ӨМЧИЙН БҮТЭЭЛИЙГ АШИГЛАХ{"\n"}ОНЦГОЙ ЛИЦЕНЗИЙН ГЭРЭЭ
        </Text>
      </View>
      <View style={styles.date}>
        <View>
          <Text>{todayDate}</Text>
        </View>
        <View>
          <Text>№MMD-CC-25-017</Text>
        </View>
        <View>
          <Text>Улаанбаатар хот</Text>
        </View>
      </View>

      <View style={styles.spaceY}>
        <Text>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Энэхүү Оюуны өмчийн бүтээлийг
          ашиглах онцгой лицензийн гэрээ /цаашид “Гэрээ” гэх/- ийг Монгол Улсын
          Иргэний хуулийг үндэслэн нэг талаас Улаанбаатар хот, Сүхбаатар
          дүүргийн 1- р хороо, Чингисийн өргөн чөлөө-17, Гурван гол оффис 6
          давхарт байрлах 6746233 регистрийн дугаартай “М Мюзик Дистрибюшн”
          ХХК-ийн Гүйцэтгэх захирал О. Мөнхтулга /цаашид “М Мюзик Дистрибюшн”
          гэх/, нөгөө талаас{" "}
          <Text style={styles.textBold}>{data?.last_name ?? "........"}.</Text>{" "}
          <Text style={styles.textBold}>{data?.first_name ?? "........"}</Text>{" "}
          -г төлөөлж{" "}
          <Text style={styles.textBold}>{data?.address ?? ".........."}.</Text>{" "}
          хаягт байрлах{" "}
          <Text style={styles.textBold}>
            {data?.registration_number ?? "..........."}
          </Text>{" "}
          регистрийн дугаартай{" "}
          <Text style={styles.textBold}>{data?.last_name ?? "........"}.</Text>{" "}
          овогтой{" "}
          <Text style={styles.textBold}>{data?.first_name ?? "........"}</Text>{" "}
          /цаашид “Эрх олгогч” гэх/ нар /цаашид “Талууд” гэх/ харилцан
          тохиролцож энэхүү Гэрээг байгуулав.
        </Text>
      </View>

      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 16 },
          ]}
        >
          НЭГ.ГЭРЭЭНИЙ НИЙТЛЭГ ҮНДЭСЛЭЛ
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>1.1.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээний зорилго нь Монгол Улсын Иргэний хууль, Барааны
            тэмдэг, газар зүйн заалтын тухай хууль, Зохиогчийн эрхийн тухай
            хууль, Оюуны өмчийн тухай хууль болон бусад холбогдох хууль
            тогтоомжийг удирдлага болгон зохиогчийн эрх бүхий аудио, дүрс бичлэг
            болон хэвлэмэл эх бүхий уран бүтээл /цаашид “Уран бүтээл” гэх/-ийг
            өөрийн болон гуравдагч талын сувгуудаар дамжуулан түрээслүүлэх,
            борлуулах, нийтэд түгээх түүнтэй холбоотойгоор үүсэх талуудын эрх
            үүргийг тодорхойлоход оршино.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>1.2.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээний хүрээнд Эрх олгогч нь М Мюзик Дистрибюшнд дараах
            аргуудаар Уран бүтээлийг нийтэд түгээх, түрээслүүлэх, борлуулах
            онцгой эрхийг олгож байна. Онцгой эрх гэдэгт Эрх олгогч нь уран
            бүтээлээ гуравдагч этгээдэд нэгэн зэрэг ашиглуулахгүй байхыг
            ойлгоно.
          </Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>1.2.1. {""}</Text>
            <Text style={styles.subtext}>
              Аудио уран бүтээл, Дууны дүрс бичлэг буюу клипийг цахимаар түгээх
              сувгуудад байршуулах, түүгээр дамжуулан түрээслүүлэх, борлуулах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>1.2.2. {""}</Text>
            <Text style={styles.subtext}>
              Аудио уран бүтээлийг цахимаар түгээх сувгуудад байршуулах, түүгээр
              дамжуулан Нийтийн үйлчилгээний байгууллагуудад түрээслүүлэх,
              борлуулах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>1.2.3. {""}</Text>
            <Text style={styles.subtext}>
              Караоке болон ижил төстэй үйлчилгээгээр дамжуулан түрээслүүлэх;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>1.2.4. {""}</Text>
            <Text style={styles.subtext}>
              Өргөн нэвтрүүлгийн Телевиз, радиогийн сувгуудад дуу, дууны дүрс
              бичлэг буюу клипийг түрээслүүлэх;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>1.2.5. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогчийн лого, зураг, агуулга бүхий хэвлэмэл эх бүхий
              бүтээгдэхүүн үйлдвэрлэх эрх түрээслэх.
            </Text>
          </View>
        </View>
        <View style={styles.spaceX}>
          <Text>1.3.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээний хүрээнд Эрх олгогч нь Mmusic аппликейшнд байршуулах
            бүтээлүүдийн жагсаалтыг гэрээний Хавсралтаар баталгаажуулах ба Эрх
            олгогч шинээр уран бүтээл гаргах бүртээ Хавсралтаар баталгаажуулж
            Mmusic аппликейшнд байршуулна.
          </Text>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 16 },
          ]}
        >
          ХОЁР. ГЭРЭЭНИЙ ХУГАЦАА
        </Text>
      </View>
    </Page>
  );
};

export default Page1;
